import { useEffect } from 'react'
import { useSpecificFeature } from 'hooks'
import { setDocumentTitle } from 'utils/documentTitle'
import ArcMarkSrc from 'assets/arcmosaico/arcmosaico-mark.svg'

/**
 * Swaps the browser tab branding (document title + favicon) to ArcMosaico
 * when the `arc-mosaico-project` flag is on. Renders nothing.
 * Uses the Flipper endpoint so it also works on unauthenticated pages (AR-792).
 */
export const ArcDocumentBranding = () => {
  const { enabled: isArcEnabled, loading: isFlagLoading } =
    useSpecificFeature('arc-mosaico-project')

  useEffect(() => {
    if (isFlagLoading || !isArcEnabled) return
    setDocumentTitle()
    const favicon = document.querySelector("link[rel='icon']")
    if (favicon) favicon.setAttribute('href', ArcMarkSrc)
  }, [isArcEnabled, isFlagLoading])

  return null
}
